module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-6@3x.jpg?28c0dd5c";